// This is the ONLY place to import useToast from the UCL.
// This is where we can set useful defaults for all toasts throughout the application.
// eslint-disable-next-line no-restricted-imports
import { useToast as useUclToast } from '@fhs-legacy/universal-components';

export const useToast = () => useUclToast({ placement: 'bottom' });
